module.exports = __webpack_public_path__ + "static/media/icon_arrowBB.85e6c9bb.svg";